// extracted by mini-css-extract-plugin
export default {"root":"ProductList_root__uWrUi","list_item":"ProductList_list_item__lTzs-","row":"ProductList_row__U0L0s"};